;(function () {
  'use strict'

  angular
    .module('contrast.attacks')
    .controller('AttackEventDashboardCtrl', AttackEventDashboardCtrl)

  function AttackEventDashboardCtrl($routeParams) {
    'ngInject'

    var vm = this

    var model = {
      eventUuid: $routeParams.eventId
    }

    angular.extend(vm, {
      getEventUuid: getEventUuid
    })

    function getEventUuid() {
      return model.eventUuid
    }
  }
})()
